app.service('menu', function(modal, loading, account, headlessMenu, focusTrap) {
	let menuHtml, menuModal;

	const loadMenu = () => {
		$.ajax({
			success: function (html) { 
				menuHtml = html;

				loading.stop();

				menuModal = modal.generate({
					id: 'headless-mobile-menu-modal',
					content: `<div id="headless-mobile-menu" tabindex="-1">${html}</div>`,
					modifier: 'remodal-full-width',
					callbackOpen: () => {
						// dodawane tylko podczas generowania modala
						checkLoggedUser();
						headlessMenu.init();
						$('#headless-mobile-menu-modal > .remodal-close').attr('aria-label', 'Zamknij menu główne');
					}, 
					callbackClose: () => {
						headlessMenu.reset();
					}
				});
			},
			url: '/top-menu.ltr'
		});
	};

	function open() {
		if (menuHtml && menuModal) {
			setTimeout(function () {		// Zwiększenie INP
				menuModal.open();
				checkLoggedUser();
			}, 1);
		} else {
			loading.start();
			setTimeout(function () {		// Zwiększenie INP
				loadMenu();
			}, 1);
		}
	}

	function checkLoggedUser() {
		account.onLoad(function(){
			const user = account.user();
			if (user) {
				$('#headless-mobile-menu .menu-account-box .js-user-name').text(user.firstname);
				$('#headless-mobile-menu .menu-favorite-box .js-clipboard-products-count').text(user.customerWatchedProductsCount).attr('data-count', user.customerWatchedProductsCount);
			}
		});
	}

	return { open };
});
